module.exports = __webpack_public_path__ + "static/pic02-40a772a08cf02ce5a485b7290fa9d8dc.jpg";